import axios from 'axios'
import {services, getHeader} from '@/assets/js/config.js'
import html2pdf from 'html2pdf.js';

export default () => {
	
	const downloadFromAttachmnetService = (attc_id, file_name="Download") => {
		axios.get(services.attachment + 'attachments/' + attc_id + '/download',{
			headers: getHeader(),
			responseType: 'blob'
		})
		.then(response => {
			_gHlp.createDownloadFileLink(response.data, file_name)
		})
		.catch(e => {
			_gNotif.errorFunction(e)
		});
	}


	const getContentUrl = async (imageUrl) => {
    const getImageAsBase64 = (url) => {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.crossOrigin = 'Anonymous'; // Enable CORS
    
            img.onload = function () {
                const canvas = document.createElement('canvas');
                canvas.width = this.width;
                canvas.height = this.height;
    
                const ctx = canvas.getContext('2d');
                ctx.drawImage(this, 0, 0);
    
                const base64String = canvas.toDataURL('image/png'); // Change format if needed
                resolve(base64String);
            };
    
            img.onerror = function () {
                reject(new Error('Failed to load image.'));
            };
    
            img.src = url;
        });
    };

    try {
        const base64String = await getImageAsBase64(imageUrl);
        return base64String;
    } catch (error) {
        console.error(error);
        return null;
    }
	};


	const htmlToPdfUrl = (html, fileName) => {
    // Use async/await to return a promise
    const generate = async (html, fileName) => {
        const opt = {
            margin: [1,1,1,1],
            filename: fileName,
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: 2 },
            jsPDF: { unit: 'cm', format: 'A4', orientation: 'portrait' }
        };

        return new Promise((resolve, reject) => {
            // Use html2pdf to generate the PDF and create an object URL
            html2pdf().from(html).set(opt).toPdf().get('pdf').then((pdf) => {
							const currentPage = pdf.internal.getCurrentPageInfo().pageNumber;
							for (let i = 1; i <= currentPage; i++) {
									pdf.setPage(i);
									pdf.setFont('helvetica', 'bold');
									pdf.setFontSize(8);
									pdf.text(`Page ${i} of ${currentPage}`, 10, pdf.internal.pageSize.height - 1);
							}

                const blob = pdf.output('blob');
                const pdfUrl = URL.createObjectURL(blob);
                resolve(pdfUrl);  // Return the pdf URL as the result of the promise
            }).catch((error) => {
                reject(error);  // Reject in case of an error
            });
        });
    };
		
    // Return the result as a promise
    return generate(html, fileName);
	}
	
	return {
		downloadFromAttachmnetService,
		getContentUrl,
		htmlToPdfUrl
	}
}
  